export const AUTH_LOGIN_BEGIN = 'AUTH_LOGIN_BEGIN';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGIN_FAILURE = 'AUTH_LOGIN_FAILURE';
export const AUTH_LOGIN_DISMISS_ERROR = 'AUTH_LOGIN_DISMISS_ERROR';
export const AUTH_LOGOUT_BEGIN = 'AUTH_LOGOUT_BEGIN';
export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
export const AUTH_LOGOUT_FAILURE = 'AUTH_LOGOUT_FAILURE';
export const AUTH_LOGOUT_DISMISS_ERROR = 'AUTH_LOGOUT_DISMISS_ERROR';
export const AUTH_REGISTER_BEGIN = 'AUTH_REGISTER_BEGIN';
export const AUTH_REGISTER_SUCCESS = 'AUTH_REGISTER_SUCCESS';
export const AUTH_REGISTER_FAILURE = 'AUTH_REGISTER_FAILURE';
export const AUTH_REGISTER_DISMISS_ERROR = 'AUTH_REGISTER_DISMISS_ERROR';
export const AUTH_FORGOT_PASSWORD_BEGIN = 'AUTH_FORGOT_PASSWORD_BEGIN';
export const AUTH_FORGOT_PASSWORD_SUCCESS = 'AUTH_FORGOT_PASSWORD_SUCCESS';
export const AUTH_FORGOT_PASSWORD_FAILURE = 'AUTH_FORGOT_PASSWORD_FAILURE';
export const AUTH_FORGOT_PASSWORD_DISMISS_ERROR = 'AUTH_FORGOT_PASSWORD_DISMISS_ERROR';
export const AUTH_VALIDATE_TOKEN_BEGIN = 'AUTH_VALIDATE_TOKEN_BEGIN';
export const AUTH_VALIDATE_TOKEN_SUCCESS = 'AUTH_VALIDATE_TOKEN_SUCCESS';
export const AUTH_VALIDATE_TOKEN_FAILURE = 'AUTH_VALIDATE_TOKEN_FAILURE';
export const AUTH_VALIDATE_TOKEN_DISMISS_ERROR = 'AUTH_VALIDATE_TOKEN_DISMISS_ERROR';
export const AUTH_RESET_PASSWORD_BEGIN = 'AUTH_RESET_PASSWORD_BEGIN';
export const AUTH_RESET_PASSWORD_SUCCESS = 'AUTH_RESET_PASSWORD_SUCCESS';
export const AUTH_RESET_PASSWORD_FAILURE = 'AUTH_RESET_PASSWORD_FAILURE';
export const AUTH_RESET_PASSWORD_DISMISS_ERROR = 'AUTH_RESET_PASSWORD_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/auth/redux/constants.js